import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=1fd30c8e&scoped=true"
var script = {}
import style0 from "./BackButton.vue?vue&type=style&index=0&id=1fd30c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd30c8e",
  null
  
)

export default component.exports